module.exports = __webpack_public_path__ + "img/0Q3B3739_L_Black_MockedUp.fcabc9a2.jpg";